export default __webpack_public_path__ + "static/media/client3.15204f28.png";